<!-- 详情弹窗 -->
<template>
  <a-modal
    title="详情"
    :width="1000"
    :confirm-loading="loading"
    :visible="visible"
    @update:visible="updateVisible"
  >
    <template #footer>
      <a-space>
        <a-button type="info" @click="updateVisible(false)">取消</a-button>
        <a-button
          v-if="data.verifyState !== '已认证'"
          type="primary"
          @click="aggreVerify"
          >通过</a-button
        >
        <a-button
          v-if="data.verifyState !== '未认证'"
          type="danger"
          @click="rejectVerify"
          >驳回</a-button
        >
      </a-space>
    </template>
    <a-form
      class="ud-form-detail"
      :label-col="{ sm: { span: 8 }, xs: { span: 8 } }"
      :wrapper-col="{ sm: { span: 16 }, xs: { span: 16 } }"
    >
      <a-row :gutter="16">
        <a-col :sm="12" :xs="24">
          <!-- 租赁点名称 -->
          <a-form-item label="团队名称:">
            <div class="ud-text-secondary">
              {{ data.corpName }}
            </div>
          </a-form-item>
          <a-form-item label="联系方式:">
            <div class="ud-text-secondary">
              {{ data.phone }}
            </div>
          </a-form-item>
          <a-form-item label="统一社会信用代码:">
            <div class="ud-text-secondary">
              {{ data.usci }}
            </div>
          </a-form-item>
          <a-form-item label="认证状态:">
            <div class="ud-text-secondary">
              {{ data.verifyState }}
            </div>
          </a-form-item>
          <!-- 管理人 -->
          <!-- <a-form-item label="店铺照片:">
            <div class="ud-text-secondary">
              <img class="photo" :src="data.corpPic" width="100" />
            </div>
          </a-form-item> -->
        </a-col>
        <a-col :sm="12" :xs="24">
          <!-- 租赁点类型 -->
          <a-form-item label="团队类型:">
            <div class="ud-text-secondary">
              {{ data.corpType }}
            </div>
          </a-form-item>
          <a-form-item label="管理员姓名:">
            <div class="ud-text-secondary">
              {{ data.adminName }}
            </div>
          </a-form-item>
          <a-form-item label="法人代表:">
            <div class="ud-text-secondary">
              {{ data.legalName }}
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" >
        <a-col :sm="12" :xs="24">
          <a-form-item label="管理员身份证号码:">
            <div class="ud-text-secondary">
              {{ data.idcard }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :sm="12" :xs="24">
          <a-form-item label="统一社会信用代码图片:">
            <div class="ud-text-secondary">
              <a-image
                :fallback="fallback"
                :src="data.usciPic + '?width=100'"
                :width="200"
                :height="100"
                :preview="{src:data.usciPic}"
              />
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top:20px;">
        <a-col :sm="12" :xs="24">
          <a-form-item label="管理员身份证正面:">
            <div class="ud-text-secondary">
              <a-image
                :fallback="fallback"
                :src="data.idcardPic + '?width=100'"
                :width="200"
                :height="100"
                :preview="{src:data.idcardPic}"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col :sm="12" :xs="24">
          <a-form-item label="管理员身份证反面:">
            <div class="ud-text-secondary">
              <a-image
                :fallback="fallback"
                :src="data.idcardPic2 + '?width=100'"
                :width="200"
                :height="100"
                :preview="{src:data.idcardPic2}"
              />
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import * as corpApi from '@/api/corp/corp.js'
export default {
  name: 'OperRecordDetail',
  emits: ['update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 数据
    data: Object
  },
  data() {
    return {
      loading: false,
      fallback:
        'data:image/png;base64,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'
    }
  },
  watch: {
    data() {}
  },
  methods: {
    // 通过认证
    aggreVerify() {
      corpApi
        .agree(this.data)
        .then((res) => {
          this.loading = true
          if (res.code === 0) {
            this.updateVisible(false)
            this.$emit('done')
          } else {
            this.$error(res.msg)
          }
        })
        .catch((error) => {
          this.loading = false
          this.$error(error.message)
        })
    },
    // 驳回认证
    rejectVerify() {
      corpApi
        .refuse(this.data)
        .then((res) => {
          this.loading = true
          if (res.code === 0) {
            this.updateVisible(false)
            this.$emit('done')
          } else {
            this.$error(res.msg)
          }
        })
        .catch((error) => {
          this.loading = false
          this.$error(error.message)
        })
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    }
  }
}
</script>

<style scoped>
:deep(.ant-image-img) {
  height: 100px;
  width: 200px;
}
</style>
